import React from 'react';
import { useTranslation } from 'react-i18next';
import { SegmentedControl } from '../ui/SegmentedControl';
import { AppLanguage, SUPPORTED_LANGUAGES } from '../../i18n/locale-resources';

// Labelled language picker; each option is shown in its own language so it is findable either way.
export const LanguageSelect = () => {
  const { t, i18n } = useTranslation();
  const current: AppLanguage = i18n.language === 'vi' ? 'vi' : 'en';

  return (
    <SegmentedControl<AppLanguage>
      ariaLabel={t('language.label')}
      value={current}
      onChange={lng => i18n.changeLanguage(lng)}
      options={SUPPORTED_LANGUAGES.map(lng => ({ value: lng, label: t('language.' + lng) }))}
    />
  );
};
